import { makeStyles } from "@material-ui/core/styles";
import { Box, IconButton, Tab, Tabs, withStyles } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import Draggable from "react-draggable";
import { useCsColorState } from "../../store/CrossSectionColorState";
import { useRecoilCallback, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { isWXContents, toggleWeatherVisibleWithID } from "../../store/WeatherContentsState";
import {
  csLegendListState,
  csLegendVisibleState,
  csSelectedLegendState,
  draggingCsLegendState,
  csLegendPanelPosition
} from "../../store/CsLegendState";
import { useATCPlan } from "../../store/ATCPlanState";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    bottom: 0,
    right: '30px',
    width: '500px',
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  panel: {
    position:'relative',
    backgroundColor: "rgba(238,238,238,.7)",
    minHeight:50,
    '& >div': {
      paddingTop:5,
      paddingBottom:5,
      paddingLeft:10,
      paddingRight:10
    }
  },
  closeButton: {
    position:'absolute',
    top:3,
    right:5
  }
}));

const LegendTabs = withStyles((theme) => ({
  root: {
    minHeight:32,
    borderBottom: '1px solid #e8e8e8',
  },
  scrollButtons: {
    backgroundColor: "rgba(238,238,238,.7)",
    opacity: '1!important',
    '&.Mui-disabled svg': {
      opacity: 0
    }
  },
  indicator: {
    backgroundColor: '#1890ff',
  },
}))(Tabs);

const LegendTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 50,
    paddingTop: 0,
    paddingBottom: 0,
    minHeight:32,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(0),
    backgroundColor: "rgba(238,238,238,.7)",
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);


function TabPanel(props) {
  const { children, id, value, index, close, ...other } = props;
  const classes = useStyles();
  const handleClose = (event) => {
    close(event ,id);
  };
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={classes.panel}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
      <IconButton size='small' className={classes.closeButton} onClick={handleClose}>
        <CloseIcon/>
      </IconButton>
    </div>
  );
}

function CrossLegendPanel () {
  const csLegendVisible = useRecoilValue(csLegendVisibleState);
  const csLegendList = useRecoilValue(csLegendListState);
  const [csSelectedLegend, changeSelectedLegend] = useRecoilState(csSelectedLegendState);
  const {csColor} = useCsColorState();
  const classes = useStyles();
  const [csLegendPosition, setCsLegendPosition] = useRecoilState(csLegendPanelPosition);
  const setCsLegendDrag = useSetRecoilState(draggingCsLegendState);
  const {atcPlan} = useATCPlan();

  const handleChange = (event, activeTab) => {
    changeSelectedLegend(activeTab)
  };

  const handleStop = () => {
    setCsLegendPosition({x: 0, y: 0});
  }

  const handleStart = () => {
    setCsLegendDrag(false);
  }

  const handleDrag = () => {
    setCsLegendDrag(true);
  }

  const toggleContents = useRecoilCallback(({set}) => id => {
    if (isWXContents(id)) {
      set(toggleWeatherVisibleWithID(id));
    }
  });

  const handleClose = (event, id) => {
    event.stopPropagation();
    toggleContents(id);
  };

  return (
    <Draggable onStop={handleStop} position={csLegendPosition} onDrag={handleDrag} onStart={handleStart}>
      <div className={`${classes.root} ${csColor}`}  hidden={csLegendList.length === 0 || !csLegendVisible || atcPlan.original.text === ""}>
        <div>
          <LegendTabs value={csSelectedLegend} onChange={handleChange} aria-label="legend" variant="scrollable"
            scrollButtons={"auto"}>
            {csLegendList.map(legend => {
              return <LegendTab key={legend.id}  label={legend.label}/>
            })}
          </LegendTabs>
          {csLegendList.map((legend, idx) => {
            const LegendComponent = legend.component;
            const contents = legend.contents;
            return (
              <TabPanel key={legend.id} id={legend.id} value={csSelectedLegend} index={idx} close={handleClose}>
                <LegendComponent contents={contents}/>
              </TabPanel>
            )
          })}
        </div>
      </div>
    </Draggable>
  )
}

export default CrossLegendPanel;